module.exports = __webpack_public_path__ + "img/icon_map_3_off_101.73583df7.png";